'use client';

import { useMemo } from 'react';
import { looksLikeHtml, sanitizeHtml } from '@/lib/richText';

/** Plain text keeps its line breaks; WYSIWYG markup is rendered, sanitized. */
export function RichDescription({ text, className = '' }: { text: string; className?: string }) {
  const html = useMemo(() => (looksLikeHtml(text) ? sanitizeHtml(text) : null), [text]);
  if (html === null) {
    return <p className={`leading-relaxed whitespace-pre-line ${className}`}>{text}</p>;
  }
  return (
    <div
      className={`leading-relaxed [&_a]:font-semibold [&_a]:text-[var(--accent-text,var(--accent,#299c8f))] [&_a]:underline [&_li]:ml-5 [&_ol]:mb-3 [&_ol]:list-decimal [&_p]:mb-3 [&_p:last-child]:mb-0 [&_strong]:font-bold [&_ul]:mb-3 [&_ul]:list-disc ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
